module.exports = __webpack_public_path__ + "static/OpenGraph-e749e6f048732f7c0d2f69565b8ce6c0.jpg";